import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa6746fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title mb-2" }

import Modal from '@/popup/components/shared/Modal/Modal'
import Network from '@/popup/components/views/Home/Settings/Network/Network/Network.vue'

type Emits = {
  (event: 'onBackgroundClick'): void
  (event: 'onNetworkSwitch', networkId: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkSelect',
  emits: ["onBackgroundClick", "onNetworkSwitch"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const onBackgroundClick = () => {
  emits('onBackgroundClick')
}

const onNetworkSwitch = (networkId: string) => {
  emits('onNetworkSwitch', networkId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "wrapper",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        onClick: onBackgroundClick,
        "extra-class": "darker\n    blurry"
      }),
      _createVNode(_unref(Modal).Content, { "extra-class": "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('modal.network_switch.switch_network')), 1 /* TEXT */),
          _createVNode(Network, {
            from: "add-account",
            onOnNetworkSwitch: onNetworkSwitch
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})